import React, { useRef, useEffect, useState } from "react";
import "../styles/CourseVerticallCard.scss";
import TooltipComponent from "./tooltipComponent";

const CourseVerticallCard = ({
  title,
  completed = 0,
  total = 0,
  statusText,
  onClick = () => {},
}) => {
  const done = Number(completed) >= Number(total) && total > 0;
  const status = statusText || (done ? "Completed" : "Not Completed");
  const titleRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const element = titleRef.current;
    if (element) {
      setIsTruncated(element.scrollHeight > element.clientHeight);
    }
  }, [title]);

  return (
    <button type="button" className="cvc-card" onClick={onClick}>
      <div className="cvc-card__left">
        {isTruncated ? (
          <TooltipComponent className="cvc-card__title">
            {title}
          </TooltipComponent>
        ) : (
          <div className="cvc-card__title" ref={titleRef}>
            {title}
          </div>
        )}
        <div className="cvc-card__meta">
          <span
            className={`cvc-dot ${done ? "cvc-dot--done" : ""}`}
            aria-hidden
          ></span>
          <span className="cvc-progress">
            {completed} / {total}
          </span>
          <span className={`cvc-status ${done ? "cvc-status--done" : ""}`}>
            {status}
          </span>
        </div>
      </div>
      <div className="cvc-card__right" aria-hidden>
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 17L17 7M17 7H9M17 7V15"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </button>
  );
};

export default CourseVerticallCard;
